const locale = {
	CONTACT: '联络擎亿',
	ISO: 'ISO 9001',
	MINERALS: '矿产政策',
	PRODUCTS: '擎亿产品',
	HOME: '擎亿首页',
	footerCompany: '擎亿精密有限公司',
	footerTagline: '瑞士型走心机 CNC 精密加工 ｜ φ1–20mm 小径精密零件，公差 ±0.005mm，ISO 9001:2015 认证。',
	footerLinks: '快速链接',
	footerContactTitle: '联系信息',
	footerAddress: '新北市树林区备内街1巷35弄5号',
	footerPhone: '0966-686-161 ／ 02-8687-2058',
	footerEmail: 'qingyi106@gmail.com',
	footerRights: '© 2026 擎亿精密有限公司. 版权所有.'
};

export default locale;
